export function checkVariableIsDefinedOrThrow(variable, variableName) {
  if(!variable) {
    throw new Error(`Variable : "${variableName} is not defined !"`);
  }
}


// WEBPACK FOOTER //
// ./src/utils/validation.js